import { List, useTheme } from "@mui/material";
import type { FC } from "react";
import { AdvisorAssistantRow } from "web_myplann/Advisor/Components/AdvisorAssistantRow";
import type { AgentAssistantResponseDTO } from "web_myplann/Infrastructure/Api/Api";

type Props = {
	assistants: AgentAssistantResponseDTO[];
	onOpenChat: (assistant: AgentAssistantResponseDTO) => void;
	onOpenDetail: (assistant: AgentAssistantResponseDTO) => void;
};

export const AdvisorAssistantList: FC<Props> = ({
	assistants,
	onOpenChat,
	onOpenDetail,
}) => {
	const theme = useTheme();

	return (
		<List disablePadding sx={{ bgcolor: theme.palette.background.paper }}>
			{assistants.map((assistant, index) => (
				<AdvisorAssistantRow
					key={assistant.uid}
					name={assistant.name}
					photo={assistant.avatar || undefined}
					phone={assistant.phone || undefined}
					email={assistant.email}
					hasUnread={assistant.unreadCount > 0}
					divider={index < assistants.length - 1}
					onOpenChat={() => onOpenChat(assistant)}
					onOpenDetail={() => onOpenDetail(assistant)}
				/>
			))}
		</List>
	);
};
